import React from "react";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { c } from "ttag";

export const BasketSidebarContent = (): React.ReactNode => {
    const phoneLink = (
        <a href={usePageSetting("pre_order_phone_number_link") || ""}>
            {usePageSetting("pre_order_phone_number_display")}
        </a>
    );
    return (
        <div>
            <div className="basket-summary__help">
                <h3>{c("BasketSidebarContent").t`Questions?`}</h3>
                <p>
                    <strong>
                        {c("BasketSidebarContent").jt`Call ${phoneLink}.`}
                    </strong>
                </p>
            </div>
        </div>
    );
};
